"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _token = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/token.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _token.default);
/** A **Token** is used to represent contextual information. It can be useful to show
applied filters, selected values for a form field or object metadata. */

var Token = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _classnames;

  var buttonLabel = _ref.buttonLabel,
      children = _ref.children,
      className = _ref.className,
      compact = _ref.compact,
      cssNamespace = _ref.cssNamespace,
      onClick = _ref.onClick,
      readOnly = _ref.readOnly,
      props = (0, _objectWithoutProperties2.default)(_ref, ["buttonLabel", "children", "className", "compact", "cssNamespace", "onClick", "readOnly"]);
  var tokenClasses = classnames("".concat(cssNamespace, "-token"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-token--readonly"), readOnly), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-token--compact"), compact), _classnames), className);
  return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, props, {
    className: tokenClasses,
    ref: ref,
    role: "button",
    tabIndex: "0"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: classnames("".concat(cssNamespace, "-token__text"))
  }, children), /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": buttonLabel,
    className: classnames("".concat(cssNamespace, "-token__close")),
    onClick: onClick,
    tabIndex: "-1"
  }));
});

Token.displayName = 'Token';
process.env.NODE_ENV !== "production" ? Token.propTypes = {
  /** A localized string to be used as aria-label for the token's button */
  buttonLabel: _propTypes.default.string.isRequired,

  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to enable compact mode */
  compact: _propTypes.default.bool,

  /** Set to **true** to mark component as readonly */
  readOnly: _propTypes.default.bool,

  /**
   * Callback function; triggered when the Token's close `<button>` is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {void}
  */
  onClick: _propTypes.default.func
} : void 0;
Token.defaultProps = {
  onClick: function onClick() {}
};

var _default = (0, _withStyles.default)(Token);

exports.default = _default;